import React, {lazy, Suspense, useEffect, useRef} from "react";
import {route} from "ziggy-js";
import {useAllStore} from "@/Stores/useAllStore";
import {useProductStore} from "@/Stores/Site/Product";
import BaseLayout from "@/Layouts/BaseLayout";
import BreadcrumbsComponent from "@/Pages/Site/Product/BreadcrumbsComponent";
import MainCarousel from "@/Pages/Site/Product/MainCarousel";
import MainInfo from "@/Pages/Site/Product/MainInfo";
import AboutDecoration from "@/Pages/Site/Product/AboutDecoration";
import Garnitur from "@/Pages/Site/Product/Garnitur";
import Reviews from "@/Pages/Site/Product/Reviews";
import Related from "@/Pages/Site/Product/Related";
import Recommend from "@/Pages/Site/Product/Recommend";
import Viewed from "@/Pages/Site/Product/Viewed";
import {dataLayerPush} from "@/Helpers/Function";
import reachGoalVkAds from "@/Helpers/ReachGoalVkAds";
import "@/Scss/Site/Product/index.scss";

const InfoDiscountModal = lazy(() => import("@/Pages/Site/Product/InfoDiscountModal"));
const WriteReviewModal = lazy(() => import("@/Components/Modal/WriteReviewModal"));
const ZoomImageModal = lazy(() => import("@/Pages/Site/Product/ZoomImageModal"));

const Index = (props) => {
    const {product = {}, product_data_current = null} = props;

    const aboutDecorationRef = useRef(null);
    const productSetRef = useRef(null);
    const reviewsRef = useRef(null);

    const initProduct = useProductStore(state => state.initProduct);
    const changeProduct = useProductStore(state => state.changeProduct);
    const deleteProduct = useProductStore(state => state.deleteProduct);

    initProduct(product, product_data_current);
    const productDataCurrent = useProductStore(state => state.productDataCurrent) ?? product_data_current;

    //
    useEffect(() => {
        changeProduct(product_data_current);

        return () => deleteProduct(product);
    }, [product]);

    useEffect(() => {
        if (!productDataCurrent) return;

        let price = productDataCurrent?.price_minimum !== 0 ? productDataCurrent?.price_minimum : productDataCurrent?.card_price;
        dataLayerPush('view_item', 'detail', 'viewItem', 'product', '',
            [{
                ...product,
                'product_id': product.id,
                'count': 1,
                'price': price,
            }]
        );
        // Отправка цели VK
        reachGoalVkAds('viewProduct', price, product.id);
    }, [product]);

    /**
     * Временное решение, принудительно поднять вверх
     */
    useEffect(() => {
        const timeout = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 700) // дать странице время дорисоваться
        return () => clearTimeout(timeout);
    }, []);

    /**
     * Добавляем в просмотренные
     */
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (product.id) {
                axios.post(route('viewed.add'), {product_id: product.id});
            }
        }, 150);
        return () => clearTimeout(timeout);
    }, [product.id]);

    return (
        <BaseLayout {...props}>
            <section className={`section section--productPage`}>
                <div className={`container`}>
                    <BreadcrumbsComponent {...props} />
                    <div className={`product`}>
                        <div className={`mainContent`}>
                            <MainCarousel
                                {...props}
                                className={`product`}
                                type={`product`}
                                productDataCurrent={productDataCurrent}
                            />
                            <MainInfo
                                {...props}
                                productDataCurrent={productDataCurrent}
                                aboutDecorationRef={aboutDecorationRef}
                                productSetRef={productSetRef}
                                reviewsRef={reviewsRef}
                            />
                        </div>
                        <AboutDecoration
                            {...props}
                            productDataCurrent={productDataCurrent}
                        />
                        <Garnitur {...props} />
                        <Reviews {...props} />
                        <Related {...props} />
                        <Recommend {...props} />
                        <Viewed {...props} />
                    </div>
                </div>
            </section>
            <Modals {...props} type={`product`} />
        </BaseLayout>
    );
}

const Modals = (props) => {
    const interactionFlag = useAllStore((state) => state.interactionFlag);

    if (!interactionFlag) return null;

    return (
        <>
            <Suspense><InfoDiscountModal {...props} /></Suspense>
            <Suspense><WriteReviewModal {...props} /></Suspense>
            <Suspense><ZoomImageModal {...props} /></Suspense>
        </>
    );
};

export default Index;
